<template>
  <div id="wrapper__inner">
    <sidemenu></sidemenu>
    <div id="content">
      <breadcrumb/>
      <transition name="fade" mode="out-in">
        <div id="content__inner">
          <router-view></router-view>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Sidemenu from "@/components/app/sidemenu.vue";
import Breadcrumb from "@/components/app/breadcrumb.vue";

export default {
  components: {
    Sidemenu,
    Breadcrumb
  }
};
</script>
